import './tokens.css';
import './styles.css';
import { boot } from './app';
import { initMotion } from './motion';

boot()
  .then(() => {
    const root = document.querySelector<HTMLElement>('#app');
    if (root) initMotion(root);
  })
  .catch((err) => {
  const root = document.querySelector('#app');
  const msg = err instanceof Error ? err.message : 'App failed to start';
  if (root) {
    root.innerHTML = `<div class="empty-state" role="alert"><p>${msg}</p></div>`;
  }
  console.error(err);
});
